import { render, staticRenderFns } from "./NPAssetCard.vue?vue&type=template&id=4b5e6374&scoped=true&"
import script from "./NPAssetCard.vue?vue&type=script&lang=js&"
export * from "./NPAssetCard.vue?vue&type=script&lang=js&"
import style0 from "./NPAssetCard.vue?vue&type=style&index=0&id=4b5e6374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e6374",
  null
  
)

export default component.exports